import { ServiceAccountService } from '@kizen/api/service-account';
import AxiosService from 'services/AxiosService';

export default new ServiceAccountService(AxiosService);
